import React, { useState } from "react";
import { Field } from "formik";
import Popup from "../popup/Popup";
import { POPUP_FORM_CONTENT_CLASS, ACTION_POPUP_CONTENT_INNER_CLASS } from "../popup/popupLayoutSpec";
import {
  AccountPopupField,
  AccountPopupSaveFooter,
} from "./accountPopupFields";
import {
  AdminPageTitle,
  AdminMainText,
  AdminMetadataText,
  adminWizardTimeInputClasses,
} from "../../sections/AdminDashboard/shared/adminUx";

const OperatingHoursPopup = ({ isOpen, onClose, setFieldValue, values, errors, initialStep = 0 }) => {
  const [currentStep] = useState(initialStep);

  const displayValues = {
    timeZone: values.timeZone || "",
    responseTime: values.responseTime || "",
  };

  const timeZoneOptions = [
    { label: "Australia/Melbourne", value: "Australia/Melbourne" },
    { label: "Australia/Sydney", value: "Australia/Sydney" },
    { label: "Australia/Brisbane", value: "Australia/Brisbane" },
    { label: "Australia/Perth", value: "Australia/Perth" },
    { label: "Australia/Adelaide", value: "Australia/Adelaide" },
    { label: "Australia/Darwin", value: "Australia/Darwin" },
    { label: "Australia/Hobart", value: "Australia/Hobart" },
  ];

  const responseTimeOptions = [
    { label: "Usually replies within 1 hour", value: "1 hour" },
    { label: "Usually replies within 4 hours", value: "4 hours" },
    { label: "Usually replies within 24 hours", value: "24 hours" },
  ];

  const steps = [
    {
      title: "Time Zone",
      field: "timeZone",
      type: "dropdown",
      options: timeZoneOptions,
    },
    {
      title: "Weekly Schedule",
      field: "weeklySchedule",
      type: "schedule",
    },
    {
      title: "Response Time",
      field: "responseTime",
      type: "dropdown",
      options: responseTimeOptions,
    },
  ];

  const handleDayToggle = (day) => {
    const dayKey = day === "P. Holiday" ? "pholiday" : day.toLowerCase();
    const isOpenDay = values[`${dayKey}Open`] !== false;
    setFieldValue(`${dayKey}Open`, !isOpenDay);
    if (!isOpenDay) {
      setFieldValue(`${dayKey}Start`, "09:00");
      setFieldValue(`${dayKey}End`, "17:00");
    }
  };

  const handleTimeChange = (day, timeType, value) => {
    const dayKey = day === "P. Holiday" ? "pholiday" : day.toLowerCase();
    setFieldValue(`${dayKey}${timeType}`, value);
  };

  const currentStepData = steps[currentStep];
  const days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
    "P. Holiday",
  ];

  if (!isOpen) return null;

  return (
    <Popup
      setTrigger={() => {}}
      ShowCrossButton={true}
      cross={true}
      onClose={onClose}
      businessDashboard={true}
      hideLogoInHeader={true}
    >
      <div
        className="overflow-auto relative flex items-center justify-center"
        style={{ minHeight: "calc(100vh - 120px)" }}
      >
        <div className={POPUP_FORM_CONTENT_CLASS}>
          <div className={ACTION_POPUP_CONTENT_INNER_CLASS}>
            <form onSubmit={(e) => e.preventDefault()}>
              <Field name={currentStepData.field}>
                {({ form }) =>
                  currentStepData.type === "schedule" ? (
                    <div>
                      <AdminPageTitle className="text-center pb-0 text-offblack mb-6">
                        {currentStepData.title}
                      </AdminPageTitle>
                      <div className="space-y-3">
                        {days.map((day) => {
                          const dayKey = day === "P. Holiday" ? "pholiday" : day.toLowerCase();
                          const isOpenDay =
                            day === "P. Holiday"
                              ? values[`${dayKey}Open`] === true
                              : values[`${dayKey}Open`] !== false;

                          return (
                            <div
                              key={day}
                              className="flex items-center justify-between py-2 border-b border-mediumgray"
                            >
                              <div className="flex items-center gap-3">
                                <button
                                  type="button"
                                  onClick={() => handleDayToggle(day)}
                                  className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-primaryblue focus:ring-offset-1 ${
                                    isOpenDay ? "bg-primaryblue" : "bg-mediumgray"
                                  }`}
                                >
                                  <span
                                    className={`inline-block h-3 w-3 transform rounded-full bg-white transition-transform ${
                                      isOpenDay ? "translate-x-5" : "translate-x-1"
                                    }`}
                                  />
                                </button>
                                <AdminMainText className="text-offblack w-24">{day}</AdminMainText>
                              </div>
                              <div className="flex items-center gap-2">
                                {isOpenDay ? (
                                  <>
                                    <input
                                      type="time"
                                      value={values[`${dayKey}Start`] || "09:00"}
                                      onChange={(e) =>
                                        handleTimeChange(day, "Start", e.target.value)
                                      }
                                      className={adminWizardTimeInputClasses()}
                                    />
                                    <AdminMetadataText className="text-mediumgray">-</AdminMetadataText>
                                    <input
                                      type="time"
                                      value={values[`${dayKey}End`] || "17:00"}
                                      onChange={(e) =>
                                        handleTimeChange(day, "End", e.target.value)
                                      }
                                      className={adminWizardTimeInputClasses()}
                                    />
                                  </>
                                ) : (
                                  <AdminMetadataText className="text-mediumgray">Closed</AdminMetadataText>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ) : (
                    <AccountPopupField
                      step={currentStepData}
                      fieldKey={currentStepData.field}
                      value={displayValues[currentStepData.field]}
                      onChange={(v) => setFieldValue(currentStepData.field, v)}
                      form={form}
                    />
                  )
                }
              </Field>
              <AccountPopupSaveFooter onClick={onClose} />
            </form>
          </div>
        </div>
      </div>
    </Popup>
  );
};

export default OperatingHoursPopup;
